import { ChangeDetectionStrategy, Component, Input, OnChanges, inject } from '@angular/core';
import { PICFLOW_STORYBLOK } from '../../../picflow-storyblok';
import { InternalRouteHelperService } from '../../../services/internal-route-helper.service';
import { StoryblokReplaceService } from '../../../services/storyblok-replace.service';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { BlockStyle } from '../../interfaces/block-style';
import { ButtonListButtonItem, ButtonListItem, ButtonListLineItem } from '../../interfaces/storyblok-buttons';
import { BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';
import { StoryblokButtonItemComponent } from '../storyblok-button-item/storyblok-button-item.component';

@Component({
  selector: 'app-storyblok-button-list',
  templateUrl: './storyblok-button-list.component.html',
  styleUrls: ['./storyblok-button-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BlockWrapperComponent, ContextMenuComponent, StoryblokButtonItemComponent],
})
export class StoryblokButtonListComponent implements OnChanges {
  private internalRouteHelperService = inject(InternalRouteHelperService);
  private storyblokReplaceService = inject(StoryblokReplaceService);
  private storyblokService = inject(PICFLOW_STORYBLOK);
  @Input() _uid: string;
  @Input() component: string;
  @Input() _editable: string;
  @Input() style: BlockStyle[];

  @Input() buttons: ButtonListItem[];
  @Input() buttonSpacing: string;

  ngOnChanges(): void {
    this.buttons = this.buttons.filter(button => {
      if (button.component === 'button_list_item' || button.component === 'button_list_line_item') {
        return this.shouldShowButton(button);
      }
      if (button.component === 'button_list_dropdown_item') {
        const ddButton = button.button[0];
        return this.shouldShowButton(ddButton);
      }
    });

    this.buttons.forEach(button => {
      if (button.component === 'button_list_dropdown_item') {
        button.dropdownButtons = button.dropdownButtons.filter(dropdownButton => {
          return this.shouldShowButton(dropdownButton);
        });
        this.resolveButtonText(button.button[0]);
        button.dropdownButtons.forEach(b => {
          if (b.component === 'button_list_item') this.resolveButtonText(b);
        });
      } else if (button.component === 'button_list_item') {
        this.resolveButtonText(button);
      }
    });
  }

  private resolveButtonText(button: ButtonListButtonItem): void {
    if (button.text) return;
    button.text = this.storyblokService.getLinkName(button.link) || '';
  }

  private shouldShowButton(button: ButtonListButtonItem | ButtonListLineItem): boolean {
    if (!button.condition) return true;
    return !!this.storyblokReplaceService.getFromKey(button.condition);
  }

  onClick(event: Event) {
    return this.internalRouteHelperService.handleClick(event);
  }
}
